module.exports = __webpack_public_path__ + "files/0a0aa194aa39cc284a3d8826cd23cfa9.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Bold.woff
// module id = 804
// module chunks = 60